import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardMedia,
  Checkbox,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import GroupIcon from "@mui/icons-material/Group";
import ErrorIcon from "@mui/icons-material/Error";
import { Delete, QrCode, Share } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import moment from "moment";
import { Postrequestcall } from "../../request/Postrequest";
import { Getrequestcall } from "../../request/Getrequest";
import {
  DELETE_TICKET,
  FETCH_TICKETS,
  FETCH_TICKETS_SHARED_WITH_SUPERVISOR,
  FETCH_TICKETS_SHARED_WITH_USER,
  UNSHARE_TICKET_WITH_USER1
} from "../../constant/Apipath";
import { BIBlack, BIBlue, BIRed } from "../../assets/helpers";
import "../../assets/css/Main.css";
import AddTicket from "./AddTicket";
import Loader from "../../common/Loader";
import Pageheader from "../common/Pageheader";
import SharedWithMeTab from "./SharedWithMeTab";
import PromptModal from "../common/PromptModal";
import ViewTicketModal from "./ViewTicketModal";
import { setShowalert } from "../../redux/actions/actions";
import { useDispatch } from "react-redux";
import ShareTicketModal from "./ShareTicketModal";
import Emptydata from "../common/Emptydata";
import { English } from "../../constant/EnglishFallback";
import AdContainer from "../common/AdContainer";
import { useParams } from "react-router-dom";
import ViewTicketsWithQR from "./ViewTicketsWithQR";

function Tickets() {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const dispatch = useDispatch();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { id } = useParams();
  const [openQRModal, setOpenQRModal] = useState(false);

  const {
    BUTTON_TEXT_ADD_TICKET = English?.Tickets?.BUTTON_TEXT_ADD_TICKET,
    TEXT_DELETE_TICKETS_DESC = English?.Tickets?.TEXT_DELETE_TICKETS_DESC,
    TEXT_DELETE_TICKETS_TITLE = English?.Tickets?.TEXT_DELETE_TICKETS_TITLE,
    TEXT_EXPIRED_TICKET_ALERT = English?.Tickets?.TEXT_EXPIRED_TICKET_ALERT,
    TEXT_MY_TICKETS = English?.Tickets?.TEXT_MY_TICKETS,
    TEXT_NO_TICKETS_PLACEHOLDER = English?.Tickets?.TEXT_NO_TICKETS_PLACEHOLDER,
    TEXT_NO_TICKETS_SHARED_PLACEHOLDER = English?.Tickets?.TEXT_NO_TICKETS_SHARED_PLACEHOLDER,
    TEXT_REMOVE_TICKETS_DESC = English?.Tickets?.TEXT_REMOVE_TICKETS_DESC,
    TEXT_REMOVE_TICKETS_TITLE = English?.Tickets?.TEXT_REMOVE_TICKETS_TITLE,
    TEXT_SEARCH_MY_TICKETS = English?.Tickets?.TEXT_SEARCH_MY_TICKETS,
    BUTTON_MODAL_DELETE = English?.Tickets?.BUTTON_MODAL_DELETE,
    TEXT_SEARCH_SHARED_TICKETS = English?.Tickets?.TEXT_SEARCH_SHARED_TICKETS,
    TEXT_SHARED_TICKET_ALERT = English?.Tickets?.TEXT_SHARED_TICKET_ALERT,
    TEXT_SHARED_WITH_ME = English?.Tickets?.TEXT_SHARED_WITH_ME,
    TEXT_TICKETS = English?.Tickets?.TEXT_TICKETS,
    TEXT_EXPIRY_DATE = English?.Tickets?.TEXT_EXPIRY_DATE,
    TEXT_ISSUED_BY = English?.Tickets?.TEXT_ISSUED_BY,
    TEXT_ISSUED_DATE = English?.Tickets?.TEXT_ISSUED_DATE,
    TEXT_TICKET_TYPE = English?.Tickets?.TEXT_TICKET_TYPE,
    TEXT_TICKET_TYPE_ALL = English?.Tickets?.TEXT_TICKET_TYPE_ALL,
    TEXT_TICKET_TYPE_VALID = English?.Tickets?.TEXT_TICKET_TYPE_VALID,
    TEXT_TICKET_TYPE_EXPIRED = English?.Tickets?.TEXT_TICKET_TYPE_EXPIRED,
    TEXT_SORT_BY_FILTER_PLACEHOLDER = English?.Tickets?.TEXT_SORT_BY_FILTER_PLACEHOLDER,
    TEXT_SORT_BY_RECENT = English?.Tickets?.TEXT_SORT_BY_RECENT,
    TEXT_SORT_BY_TYPE = English?.Tickets?.TEXT_SORT_BY_TYPE
  } = multiLanguageData?.Tickets || {};

  const [myTickets, setMyTickets] = useState([]);
  const [sharedTicktes, setSharedTicktes] = useState([]);
  const [editTicketData, setEditTicketData] = useState([]);
  const [shareData, setShareData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddTicket, setShowAddTicket] = useState(false);
  const [anySelected, setAnySelected] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [deleteMessageModel, setDeleteMessageModel] = useState(false);
  const [enableDelete, setEnabledelete] = useState(false);
  const [showTicket, setShowTicket] = useState(false);
  const [ticketFlag, setTicketFlag] = useState("");
  const [selectedTicketData, setSelectedTicketData] = useState(null);
  const [fromFlag, setFromFlag] = useState("");
  const [allState, setAllState] = useState({
    value: typeof id === "undefined" || id === null ? 0 : 1,
    filter: "All",
    sorting: "Recent",
    inputText: ""
  });
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [totalRecords, setTotalRecords] = useState(0);
  const [supervisorSharedData, setSupervisorSharedData] = useState([]);
  const [supervisorLoading, setSupervisorLoading] = useState(false);
  const [supervisorPageNo, setSupervisorPageNo] = useState(1);
  const [supervisorHasMore, setSupervisorHasMore] = useState(true);

  const SUPERVISOR_PAGE_SIZE = 100;

  const fetchUserTicket = useCallback(
    async (sortBy, page = 1, append = false) => {
      let allTicketsArray = [];
      if (!append) {
        setLoading(true);
      }
      try {
        const getObj = {
          PageNr: page,
          NrOfRecPerPage: 20,
          UserId: loginData?.userInformation?.UserId,
          IncludeRecordNr: true,
          TypeOfObjectReturned: "",
          FullSearch: allState.inputText,
          SearchList: [{ createdBy: loginData?.userInformation?.UserId }],
          SortList: [{ FieldName: sortBy, Direction: "DESC" }]
        };
        let getUserTickets = await Postrequestcall(FETCH_TICKETS, getObj, loginData?.accessToken);
        if (getUserTickets?.status === 201) {
          if (getUserTickets?.data?.status === true || getUserTickets.status === 200) {
            const totalCount = getUserTickets?.data?.nrOfRecords || 0;
            setTotalRecords(totalCount);

            const ticketWithSelection = getUserTickets?.data?.data.map((item) => ({
              ...item,
              isSelected: false
            }));

            const validTicket = ticketWithSelection.filter((value) => {
              const current = moment().format("YYYY-MM-DDThh:mm:ss");
              if (value.expiry >= current || value.expiry === "" || value?.expiry === null)
                return true;
              return false;
            });
            const expiredTicket = ticketWithSelection.filter((value) => {
              const current = moment().format("YYYY-MM-DDTHH:mm:ss");
              return value.expiry && value.expiry <= current;
            });

            if (sortBy === "Expiry") {
              allTicketsArray = [
                ...expiredTicket.sort((a, b) => {
                  let dateA = new Date(a.issuedOn),
                    dateB = new Date(b.issuedOn);
                  return dateB - dateA;
                }),
                ...validTicket.sort((a, b) => {
                  let dateA = new Date(a.issuedOn),
                    dateB = new Date(b.issuedOn);
                  return dateB - dateA;
                })
              ];
            } else {
              allTicketsArray = [
                ...validTicket.sort((a, b) => {
                  let dateA = new Date(a.issuedOn),
                    dateB = new Date(b.issuedOn);
                  return dateB - dateA;
                }),
                ...expiredTicket.sort((a, b) => {
                  let dateA = new Date(a.issuedOn),
                    dateB = new Date(b.issuedOn);
                  return dateB - dateA;
                })
              ];
            }

            let filteredTickets = allTicketsArray;
            if (allState.filter === "Valid") {
              filteredTickets = allTicketsArray.filter((value) => {
                const current = moment().format("YYYY-MM-DDThh:mm:ss");
                if (value.expiry >= current || value.expiry === "") return true;
                return false;
              });
            } else if (allState.filter === "Expired") {
              filteredTickets = allTicketsArray.filter((value) => {
                const current = moment().format("YYYY-MM-DDThh:mm:ss");
                return value.expiry <= current && value.expiry !== ""; // Return a boolean
              });
            }

            if (append) {
              setMyTickets((prev) => {
                const newTickets = [...prev, ...filteredTickets];
                const hasMoreData = newTickets.length < totalCount;
                // Check if there are more records to load
                setHasMore(hasMoreData);
                return newTickets;
              });
            } else {
              const hasMoreData = filteredTickets.length < totalCount;
              setMyTickets(filteredTickets);
              // Check if there are more records to load
              setHasMore(hasMoreData);
            }
          } else if (getUserTickets.status === 401) {
            setMyTickets([]);
            setHasMore(false);
            alert(getUserTickets?.data?.errorMessage ?? getUserTickets?.data?.message);
          }
        }
      } catch (error) {
        console.log("fetchUserTicket-> Error When Fetching Tickets: ", error);
        setHasMore(false);
      } finally {
        if (!append) {
          setLoading(false);
        }
      }
    },
    [
      allState.filter,
      allState.inputText,
      loginData?.accessToken,
      loginData?.userInformation?.UserId
    ]
  );

  const fetchSharedTicket = useCallback(async (searchText = "") => {
    setLoading(true);
    try {
      const getUserTickets = await Getrequestcall(
        FETCH_TICKETS_SHARED_WITH_USER + "/" + loginData?.userInformation?.UserId,
        loginData?.accessToken
      );
      if (getUserTickets.status === 200) {
        const tickets = getUserTickets?.data?.data || [];
        if (tickets.length === 0) {
          setSharedTicktes([]);
        } else {
          const ticketData = tickets.map((ticket) => ({
            ...ticket,
            id: ticket.id || 0,
            ticketOwnerId: ticket.ticketOwnerId || 0,
            isSelected: false
          }));
          const sortedData = ticketData.sort((a, b) => a.ticketType.localeCompare(b.ticketType));
          const groupedTickets = groupTicketsByOwner(sortedData);

          if (searchText !== "") {
            const normalizedSearch = searchText.toLowerCase();
            const updatedSharedList = groupedTickets.map((sharer) => {
              sharer.tickets = sharer.tickets.filter(
                (ticket) =>
                  ticket.ticketType?.toLowerCase().includes(normalizedSearch) ||
                  ticket.issuedBy?.toLowerCase().includes(normalizedSearch) ||
                  ticket.ticketOwner?.toLowerCase().includes(normalizedSearch)
              );
              return sharer;
            });
            const newSharedList = updatedSharedList.filter((sharer) => sharer.tickets.length !== 0);
            setSharedTicktes(newSharedList);
            return;
          }
          setSharedTicktes(groupedTickets);
        }
      } else if (getUserTickets.status === 401) {
        setSharedTicktes([]);
        const ticketResponse = getUserTickets?.data;
        const errorMessage = ticketResponse?.errorMessage || ticketResponse?.message;
        alert(errorMessage);
      }
    } catch (error) {
      console.log("fetchSharedTicket-> Error When Fetching Shared Ticket: ", error);
    } finally {
      setLoading(false);
    }
  }, [loginData?.accessToken, loginData?.userInformation?.UserId]);

  const groupTicketsByOwner = (tickets) => {
    const groupedTickets = tickets.reduce((acc, ticket) => {
      const existingOwner = acc.find((group) => group.name === ticket.ticketOwner);
      if (existingOwner) {
        existingOwner.tickets.push(ticket);
      } else {
        acc.push({
          key: ticket.id,
          name: ticket.ticketOwner,
          ticketOwnerPicture: ticket.ticketOwnerPicture,
          ticketOwnerEmail: ticket.ticketOwnerEmail,
          isExpanded: false,
          isAllSelected: false,
          tickets: [ticket]
        });
      }
      return acc;
    }, []);
    return groupedTickets;
  };

  const fetchSupervisorSharedData = useCallback(async (page = 1, reset = false, searchText = "") => {
    if (page === 1) setSupervisorLoading(true);
    try {
      const payload = {
        PageNr: page,
        NrOfRecPerPage: SUPERVISOR_PAGE_SIZE,
        FullSearch: searchText,
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        SearchList: [{ supervisorId: loginData?.userInformation?.UserId }],
        SortList: [{ FieldName: "Id", Direction: "DESC" }]
      };
      const res = await Postrequestcall(
        FETCH_TICKETS_SHARED_WITH_SUPERVISOR,
        payload,
        loginData?.accessToken
      );
      if (res?.status === 200 || res?.status === 201) {
        const newData = res?.data?.data || [];
        setSupervisorSharedData((prev) => (reset ? newData : [...prev, ...newData]));
        setSupervisorHasMore(newData.length === SUPERVISOR_PAGE_SIZE);
        setSupervisorPageNo(page);
      }
    } catch (error) {
      console.log("fetchSupervisorSharedData Error:", error);
    } finally {
      if (page === 1) setSupervisorLoading(false);
    }
  }, [loginData?.accessToken, loginData?.userInformation?.UserId]);

  const loadMoreSupervisorShared = () => {
    if (supervisorHasMore) {
      fetchSupervisorSharedData(supervisorPageNo + 1, false, allState.inputText);
    }
  };

  const handleInputTextChange = (e) => {
    e.preventDefault();
    let inputValue = e.target.value;
    const cleanedValue = (inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, ""));
    if (cleanedValue !== allState?.inputText) {
      setAllState((prevState) => ({
        ...prevState,
        inputText: inputValue
      }));
      setAnySelected(false);
      setPageNumber(1);
      setHasMore(true);
    }
  };

  const handleFilterTypeChange = (event) => {
    setAllState({
      ...allState,
      filter: event.target.value
    });
    setAnySelected(false);
    setPageNumber(1);
    setHasMore(true);
  };

  const handleSortingTypeChange = (event) => {
    setAllState({
      ...allState,
      sorting: event.target.value
    });
    setAnySelected(false);
    setPageNumber(1);
    setHasMore(true);
  };

  const handleChange = (event, newValue) => {
    setAllState({
      ...allState,
      value: newValue
    });
    setAnySelected(false);
    setEnabledelete(false);
    setPageNumber(1);
    setHasMore(true);
  };

  const handleToggelSelected = (id) => {
    setMyTickets((prevTickets) => {
      const updatedTickets = prevTickets.map((ticket) =>
        ticket.id === id ? { ...ticket, isSelected: !ticket.isSelected } : ticket
      );
      const hasSelectedTickets = updatedTickets.some((ticket) => ticket.isSelected);
      setAnySelected(hasSelectedTickets);
      return updatedTickets;
    });
  };

  const getSortByType = (changeByType) => {
    switch (changeByType) {
      case "Recent":
        return "DateModified";
      case "Issued By":
        return "IssuedBy";
      case "Issued Date":
        return "IssuedOn";
      case "Expiry Date":
        return "Expiry";
      case "Type":
        return "TicketType";
      default:
        alert("Please Select A Proper Type");
        return "Id";
    }
  };

  const isExpired = (expiryDate) => {
    if (expiryDate === "" || expiryDate === null) return;
    const currentDate = new Date();
    const expiry = new Date(expiryDate);
    return expiry < currentDate;
  };

  const handleEditIconClick = (e, item) => {
    e.stopPropagation();
    e.preventDefault();
    setTicketFlag("home");
    setSelectedTicketData(item);
    setShowAddTicket(true);
  };

  const handleViewClick = (ticket) => {
    setShowTicket(true);
    setEditTicketData(ticket);
  };

  const closeAddTicketModal = () => {
    setShowAddTicket(false);
  };

  const handleDeleteTicket = async () => {
    let getSelected = await Promise.all(
      myTickets
        .filter((item) => item.isSelected === true)
        .map(async (item) => {
          const deleteObj = {
            UserId: loginData?.userInformation?.UserId,
            ReturnRecordId: true,
            DeleteList: [
              {
                Id: item?.id,
                modifiedBy: loginData?.userInformation?.UserId
              }
            ]
          };
          const getResponse = await Postrequestcall(
            DELETE_TICKET,
            deleteObj,
            loginData?.accessToken
          );

          if (getResponse.status === 201) {
            setEnabledelete(false);
            setAnySelected(false);
            setDeleteMessageModel(false);
            return true;
          }
        })
    );
    if (getSelected.length > 0) {
      if (getSelected[0] === true) {
        setPageNumber(1);
        setHasMore(true);
        await fetchUserTicket(getSortByType(allState.sorting), 1, false);
      }
    }
    setDeleteMessageModel(false);
  };

  const handleShareDelete = async () => {
    try {
      let selectedTicketIds = sharedTicktes.flatMap((parent) =>
        parent.tickets.filter((ticket) => ticket.isSelected === true)
      );
      if (selectedTicketIds.length > 0) {
        let getUpdatedlist = selectedTicketIds.map((item) => {
          return {
            TicketId: item?.id,
            UserId: item?.ticketOwnerId,
            SharedWithUserEmail: loginData?.userInformation?.Email
          };
        });
        setLoading(true);
        const deleteObj = {
          UserId: loginData?.userInformation?.UserId,
          ReturnRecordId: true,
          DeleteList: getUpdatedlist ?? []
        };
        const getResponse = await Postrequestcall(
          UNSHARE_TICKET_WITH_USER1,
          deleteObj,
          loginData?.accessToken
        );
        if (getResponse.status === 201) {
          setDeleteMessageModel(false);
          setLoading(false);
          setEnabledelete(false);
          await fetchSharedTicket();
        } else {
          setDeleteMessageModel(false);
          setLoading(false);
        }
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleShowShareModal = () => {
    const share = myTickets.filter((ticket) => ticket.isSelected);
    setShareData(share);
    setShowShareModal(true);
  };

  const handleCloseShareModal = () => {
    setShowShareModal(false);
    setAllState({
      value: 0,
      filter: "All",
      sorting: "Recent",
      inputText: ""
    });
    setAnySelected(false);
    setEnabledelete(false);
  };

  const handleCloseDeleteModal = () => {
    setDeleteMessageModel(false);
  };

  const handleMessage = (icon) => {
    if (icon === "GroupIcon") {
      let alertObj = {
        showAlert: true,
        text2: TEXT_SHARED_TICKET_ALERT
      };
      dispatch(setShowalert(alertObj));
    } else if (icon === "ErrorIcon") {
      let alertObj = {
        showAlert: true,
        text2: TEXT_EXPIRED_TICKET_ALERT
      };
      dispatch(setShowalert(alertObj));
    }
  };

  const handleSelectAllShared = (e, data) => {
    e.stopPropagation();
    const updatedData = sharedTicktes.map((ticket) => {
      if (data.key === ticket.key && ticket.tickets.length > 0) {
        const updateMiniTicket = ticket.tickets.map((mini) => {
          return { ...mini, isSelected: !ticket.isAllSelected };
        });
        return {
          key: ticket.key,
          name: ticket.name,
          isExpanded: ticket.isExpanded,
          ticketOwnerEmail: ticket.ticketOwnerEmail,
          ticketOwnerPicture: ticket.ticketOwnerPicture,
          isAllSelected: !ticket.isAllSelected,
          tickets: updateMiniTicket
        };
      }
      return { ...ticket };
    });

    const newUpdatedData = updatedData.map((item) => ({
      ...item,
      isExpanded: true
    }));

    if (newUpdatedData.some((item) => item.isAllSelected === true)) {
      setEnabledelete(true);
    } else {
      setEnabledelete(false);
    }

    setSharedTicktes(newUpdatedData);
  };

  const handleToggleSharedSingleTicket = (e, data, miniTicketID) => {
    const updatedData = sharedTicktes?.map((mainTicket) => {
      if (mainTicket.id === data.id && mainTicket.tickets.length > 0) {
        const updatedMini = mainTicket.tickets.map((mini) => {
          if (mini.id === miniTicketID) {
            return { ...mini, isSelected: !mini.isSelected };
          }
          return mini;
        });
        const allSelected = updatedMini.every((mini) => mini.isSelected);
        const updatedMainTicket = {
          key: mainTicket.key,
          name: mainTicket.name,
          isExpanded: mainTicket.isExpanded,
          ticketOwnerEmail: mainTicket.ticketOwnerEmail,
          ticketOwnerPicture: mainTicket.ticketOwnerPicture,
          tickets: updatedMini,
          isAllSelected: allSelected
        };

        return updatedMainTicket;
      }
      return mainTicket;
    });

    if (updatedData?.length > 0) {
      let getDeleted = updatedData?.flatMap((item) =>
        item?.tickets?.filter((item) => item.isSelected === true)
      );
      if (getDeleted?.length > 0) {
        setEnabledelete(true);
      } else {
        setEnabledelete(false);
      }
    }
    setSharedTicktes(updatedData);
  };

  const handleExpandAccordian = (e, data) => {
    const updatedData = sharedTicktes.map((ticket) => {
      if (ticket.key === data.key) {
        return { ...(data.isExpanded = !data.isExpanded) };
      }
      return ticket;
    });
    setShareData(updatedData);
  };

  const fetchMoreTickets = useCallback(() => {
    if (!hasMore) {
      console.log("No more data to fetch, returning early");
      return;
    }
    const nextPage = pageNumber + 1;
    setPageNumber(nextPage);
    fetchUserTicket(getSortByType(allState.sorting), nextPage, true);
  }, [pageNumber, hasMore, allState.sorting, fetchUserTicket]);

  const onActionbutton = () => {
    if (allState.value === 0) {
      setShowAddTicket(!showAddTicket);
      setTicketFlag("add");
    } else {
      setDeleteMessageModel(true);
    }
  };

  useEffect(() => {
    setPageNumber(1);
    setHasMore(true);

    if (allState.value === 0) {
      fetchUserTicket(getSortByType(allState.sorting), 1, false);
      return;
    }

    if (allState.value === 1) {
      const searchText = allState.inputText.trim();
      const timer = setTimeout(() => {
        setSupervisorPageNo(1);
        setSupervisorHasMore(true);
        fetchSupervisorSharedData(1, true, searchText);
        fetchSharedTicket(searchText);
      }, 450);

      return () => clearTimeout(timer);
    }
  }, [
    allState.value,
    allState.filter,
    allState.sorting,
    allState.inputText,
    fetchSharedTicket,
    fetchSupervisorSharedData
  ]);

  const handleClearSearch = () => {
    setAllState((prevState) => ({
      ...prevState,
      inputText: ""
    }));
    setAnySelected(false);
    setPageNumber(1);
    setHasMore(true);
  };

  const openQrCode = () => {
    setOpenQRModal(true);
  };

  return (
    <>
      <Box className="main-content-Box" sx={{ p: isSmallScreen ? 2 : 3, pt: 2 }}>
        <Pageheader headerName={TEXT_TICKETS} />

        <Card className="main-content-card">
          <Grid
            container
            spacing={{ xs: 1, md: 2 }}
            sx={{ alignItems: "center", justifyContent: "space-between" }}
            pb={1}>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 3.5, xl: 3.5 }}>
              <Tabs
                variant="fullWidth"
                aria-label="basic tabs example"
                value={allState.value}
                onChange={handleChange}>
                <Tab label={TEXT_MY_TICKETS} />
                <Tab label={TEXT_SHARED_WITH_ME} />
              </Tabs>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 3.5, xl: 3.5 }}>
              <Stack direction={"row"} alignItems={"center"} justifyContent={"flex-end"} spacing={1}>
                <TextField
                  fullWidth
                  id="outlined-basic"
                  label={allState.value === 0 ? TEXT_SEARCH_MY_TICKETS : TEXT_SEARCH_SHARED_TICKETS}
                  variant="outlined"
                  size="small"
                  value={allState.inputText}
                  onChange={handleInputTextChange}
                  slotProps={{
                    input: {
                      endAdornment:
                        allState.inputText !== "" ? (
                          <InputAdornment position="end">
                            <IconButton onClick={handleClearSearch}>
                              <CloseIcon />
                            </IconButton>
                          </InputAdornment>
                        ) : null
                    }
                  }}
                />
                {anySelected && (
                  <Box display={{ xs: "flex", md: "none" }} alignItems="center">
                    <IconButton onClick={handleShowShareModal}>
                      <Share sx={{ color: BIBlue }} />
                    </IconButton>
                    <IconButton onClick={() => setDeleteMessageModel(true)}>
                      <Delete sx={{ color: BIRed }} />
                    </IconButton>
                  </Box>
                )}
                {allState.value === 1 && (
                  <Stack direction="row" alignItems="center" spacing={1} flexShrink={0}>
                    <Button
                      size="large"
                      variant="contained"
                      sx={{ background: BIRed, whiteSpace: "nowrap" }}
                      onClick={onActionbutton}
                      disabled={!enableDelete}>
                      {BUTTON_MODAL_DELETE}
                    </Button>
                    <IconButton onClick={() => setOpenQRModal(true)}>
                      <QrCode sx={{ color: BIBlack }} fontSize="large" />
                    </IconButton>
                  </Stack>
                )}
              </Stack>
            </Grid>
            {allState?.value === 0 && (
              <Grid
                pt={{ xs: 1, md: 0 }}
                justifyContent={"end"}
                sx={{ alignItems: "center" }}
                size={{ xs: 12, sm: 12, md: 12, lg: 5, xl: 5 }}>
                <Stack
                  direction={"row"}
                  justifyContent={"flex-end"}
                  alignItems={"center"}
                  spacing={1}>
                  {allState?.value === 0 && (
                    <>
                      <FormControl size="small" sx={{ width: "100%" }}>
                        <InputLabel id="demo-simple-select-autowidth-label">
                          {TEXT_TICKET_TYPE}
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-autowidth-label"
                          id="demo-simple-select-autowidth"
                          value={allState.filter}
                          onChange={handleFilterTypeChange}
                          sx={{ width: "100%" }}
                          label="Ticket type">
                          <MenuItem value={"All"}>{TEXT_TICKET_TYPE_ALL}</MenuItem>
                          <MenuItem value={"Valid"}>{TEXT_TICKET_TYPE_VALID}</MenuItem>
                          <MenuItem value={"Expired"}>{TEXT_TICKET_TYPE_EXPIRED}</MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl size="small" sx={{ width: "100%" }}>
                        <InputLabel id="demo-simple-select-autowidth-label">
                          {TEXT_SORT_BY_FILTER_PLACEHOLDER}
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-autowidth-label"
                          id="demo-simple-select-autowidth"
                          value={allState.sorting}
                          onChange={handleSortingTypeChange}
                          sx={{ width: "100%" }}
                          label="Sort By">
                          <MenuItem value={"Recent"}>{TEXT_SORT_BY_RECENT}</MenuItem>
                          <MenuItem value={"Issued By"}>{TEXT_ISSUED_BY}</MenuItem>
                          <MenuItem value={"Issued Date"}>{TEXT_ISSUED_DATE}</MenuItem>
                          <MenuItem value={"Expiry Date"}>{TEXT_EXPIRY_DATE}</MenuItem>
                          <MenuItem value={"Type"}>{TEXT_SORT_BY_TYPE}</MenuItem>
                        </Select>
                      </FormControl>
                      <Button
                        fullWidth
                        variant="contained"
                        sx={{ background: BIBlue, padding: { xs: "6px 16px", md: "8px 22px" } }}
                        onClick={onActionbutton}
                        disabled={allState.value === 1 ? !enableDelete : false}>
                        {BUTTON_TEXT_ADD_TICKET}
                      </Button>
                      <IconButton onClick={() => openQrCode()}>
                        <QrCode sx={{ color: BIBlack }} fontSize="large" />
                      </IconButton>
                    </>
                  )}
                  {allState?.value === 0 && anySelected && (
                    <Box display={{ xs: "none", md: "flex" }}>
                      <IconButton onClick={handleShowShareModal}>
                        <Share sx={{ color: BIBlue }} />
                      </IconButton>
                      <IconButton onClick={() => setDeleteMessageModel(true)}>
                        <Delete sx={{ color: BIRed }} />
                      </IconButton>
                    </Box>
                  )}
                  <Box display={{ xs: "none", lg: "flex" }}>
                    {allState.value === 1 && (
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={onActionbutton}
                        disabled={allState.value === 1 ? !enableDelete : false}>
                        {BUTTON_MODAL_DELETE}
                      </Button>
                    )}
                  </Box>
                </Stack>
              </Grid>
            )}
          </Grid>
          <Divider />
          <Box
            className="main-content-card-list"
            pt={1.5}
            id="scrollableTicketList"
            sx={{ overflow: "auto", height: "calc(100vh - 280px)" }}>
            {loading ? (
              <Loader fullScreen />
            ) : allState.value === 0 && myTickets?.length > 0 ? (
              <InfiniteScroll
                dataLength={myTickets.length}
                next={fetchMoreTickets}
                hasMore={hasMore}
                scrollableTarget="scrollableTicketList"
                scrollThreshold={0.9}
                loader={
                  <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
                    <Loader />
                  </Box>
                }>
                <Grid container spacing={{ xs: 1.5, md: 2 }}>
                  {myTickets?.map((ticket, index) => (
                    <Grid
                      key={ticket.id || index} // Prefer a stable and unique id if available
                      size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 3 }}>
                      <Card
                        className="pagelist-content"
                        sx={{
                          backgroundColor: isExpired(ticket.expiry) === true ? "#FABEBE" : ""
                        }}>
                        <CardMedia
                          component="img"
                          height="200"
                          image={ticket?.frontPictureUrl}
                          alt="Front Picture"
                          sx={{ cursor: "pointer" }}
                          onClick={() => handleViewClick(ticket)}
                        />
                        <CardActions
                          disableSpacing
                          sx={{ flexDirection: "column", alignItems: "baseline" }}>
                          <Stack
                            direction="row"
                            spacing={0.1}
                            justifyContent={"space-between"}
                            width={"100%"}>
                            <Stack direction={"row"} alignItems={"center"}>
                              <Checkbox
                                color="primary"
                                checked={ticket.isSelected}
                                onChange={() => handleToggelSelected(ticket.id)}
                                inputProps={{ "aria-label": "controlled" }}
                                sx={{
                                  color: BIBlue,
                                  padding: "5px"
                                }}
                              />
                              <Typography
                                variant="body1"
                                sx={{ maxWidth: { xs: "110px", md: "150px" } }}
                                noWrap>
                                {ticket?.ticketType}
                              </Typography>
                            </Stack>
                            <Stack direction={"row"} alignItems={"center"}>
                              {isExpired(ticket.expiry) === true && (
                                <IconButton
                                  color="secondary"
                                  size="small"
                                  aria-label="add to favorites"
                                  onClick={() => handleMessage("ErrorIcon")}>
                                  <ErrorIcon fontSize="small" />
                                </IconButton>
                              )}
                              {ticket.sharedTicketsList?.length !== 0 && (
                                <IconButton
                                  color="default"
                                  size="small"
                                  aria-label="group"
                                  onClick={() => handleMessage("GroupIcon")}>
                                  <GroupIcon fontSize="small" />
                                </IconButton>
                              )}
                              <IconButton
                                color="primary"
                                size="small"
                                aria-label="edit"
                                onClick={(e) => handleEditIconClick(e, ticket)}>
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </Stack>
                          </Stack>
                          <Typography
                            pl={1}
                            variant="body1"
                            sx={{ maxWidth: { xs: "200px", md: "250px" } }}
                            noWrap>
                            {ticket?.issuedBy}
                          </Typography>
                        </CardActions>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </InfiniteScroll>
            ) : allState.value === 1 ? (
              <SharedWithMeTab
                sharedData={sharedTicktes}
                supervisorSharedData={supervisorSharedData}
                supervisorLoading={supervisorLoading}
                supervisorHasMore={supervisorHasMore}
                loadMoreSupervisorShared={loadMoreSupervisorShared}
                fetchSupervisorSharedData={fetchSupervisorSharedData}
                handleSelectAllShared={handleSelectAllShared}
                handleExpandAccordian={handleExpandAccordian}
                isExpired={isExpired}
                handleViewClick={handleViewClick}
                handleToggleSharedSingleTicket={handleToggleSharedSingleTicket}
                handleMessage={handleMessage}
                setTicketFlag={setTicketFlag}
                userId={id}
              />
            ) : (
              <Box className="empty-data-card">
                <Emptydata
                  icon={<CreditCardIcon className="emptydata-icon" />}
                  firstText={
                    allState.value === 0
                      ? TEXT_NO_TICKETS_PLACEHOLDER
                      : TEXT_NO_TICKETS_SHARED_PLACEHOLDER
                  }
                />
              </Box>
            )}

            {showAddTicket && (
              <AddTicket
                openModal={showAddTicket}
                closeModal={() => closeAddTicketModal()}
                removeSelectedTickets={() => setAnySelected(false)}
                fetchUserTicket={fetchUserTicket}
                editTicketItemDetails={selectedTicketData}
                setShowTicket={setShowTicket}
                ticketFlag={ticketFlag}
                setEditTicketData={setEditTicketData}
                setTicketFlag={setTicketFlag}
                setFromFlag={setFromFlag}
              />
            )}

            {showTicket && (
              <ViewTicketModal
                openModal={showTicket}
                closeModal={() => setShowTicket(false)}
                editTicketData={editTicketData}
                setShowAddTicket={setShowAddTicket}
                setSelectedTicketData={setSelectedTicketData}
                setTicketFlag={setTicketFlag}
                ticketFlag={ticketFlag}
                allState={allState}
                fetchUserTicketData={fetchUserTicket}
                fromFlag={fromFlag}
                setFromFlag={setFromFlag}
              />
            )}

            {showShareModal && (
              <ShareTicketModal
                isOpen={showShareModal}
                close={handleCloseShareModal}
                tickets={shareData}
                fetchUserTicket={fetchUserTicket}
                setFromFlag={setFromFlag}
              />
            )}

            {deleteMessageModel && (
              <PromptModal
                isOpen={deleteMessageModel}
                onClose={handleCloseDeleteModal}
                title={allState.value === 0 ? TEXT_DELETE_TICKETS_TITLE : TEXT_REMOVE_TICKETS_TITLE}
                desc={allState.value === 0 ? TEXT_DELETE_TICKETS_DESC : TEXT_REMOVE_TICKETS_DESC}
                redButtonText={BUTTON_MODAL_DELETE}
                onRedButtonClick={allState.value === 0 ? handleDeleteTicket : handleShareDelete}
              />
            )}
          </Box>
          <AdContainer />
          <ViewTicketsWithQR
            open={openQRModal}
            handleClose={() => setOpenQRModal(false)}
            loginData={loginData}
          />
        </Card>
      </Box>
    </>
  );
}

export default Tickets;
